EmailFormIntlMainView = require "./main_view"
SharedAjaxError = require "../../../../../shared/frontend/views/ajax_error_view"

class EmailFormIntlVerticalView extends EmailFormIntlMainView

  toHash: ->
    hash = EmailFormIntlMainView::toHash.call(this)
    hash.isVertical = true
    hash

  renderTicketCreateError: ->
    @hideSubmitButton()
    errorView = new SharedAjaxError()
    errorView.render({container: $('#v2-step3-form'), isVertical: true})

  hideSubmitButton: ->
  	$('.step-three .submit-button').hide()

  submitForm: (data)->
    createTicket(data, @renderSuccess, @renderTicketCreateError, $('#v2-step3-form'))

module.exports = EmailFormIntlVerticalView
